export const GET_CRM_CUSTOMER = 'GET_CRM_CUSTOMER';

export const GET_CRM_CUSTOMER_SUCCESS = 'GET_CRM_CUSTOMER_SUCCESS';

export const GET_CRM_CUSTOMER_FAILED = 'GET_CRM_CUSTOMER_FAILED';